import MainLayout from "@/components/layout/MainLayout.vue";
import { mapGetters } from "vuex";
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { maxLength } from "vuelidate/lib/validators";
import AttendanceStatus from "@/assets/json/attendanceStatus.json";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
  name: "attendanceCreate",

  components: {
    MainLayout,
  },

  data() {
    return {
      classArr: [],
      classSessionArr: [],
      makeAllStatus: null,
      attendanceData: {
        selectedClassId: "",
        selectedSessionId: ""
      },
      submission: false,
      AttStatus: AttendanceStatus,
      submitted: false,
      lastPage: '',
      currentPage: '',
      pg_status: false,
      classStudents: []
    };
  },

  validations: {
    attendanceData: {
      selectedClassId: {
        required
      },
      selectedSessionId: {
        required
      },
    },
    classStudents: {
      $each: {
        remark: { maxLength: maxLength(255) },
        status: {
          conditionalRequired(value, parent) {
            if (parent.remark && parent.remark.trim() !== "") {
              return !!value;
            }
            return true;
          },
        }
      },
    }
  },

  computed: {
    ...mapGetters(["teacherId", "studentId", "userType"]),
  },

  watch: {
    classStudents: {
      handler(newArr) {
        if (newArr.length === 0) return;

        const uniqueStatuses = [...new Set(newArr.map(s => s.status))];

        if (uniqueStatuses.length === 1) {
          this.makeAllStatus = uniqueStatuses[0];
        }
        else {
          this.makeAllStatus = null;
        }
      },
      deep: true
    }
  },

  methods: {
    getAllClassForAttendance() {
      axios.get('my/attendance')
        .then((res) => {
          this.classArr = res.data;
        })
        .catch((err) => {
          this.logout(err)
        })
    },

    setAllStatus(status) {
      if (!status) return;
      this.classStudents.forEach(student => {
        student.status = status;
      });
      this.makeAllStatus = status
    },

    onClassChange() {
      if (!this.attendanceData.selectedClassId) return;
      this.attendanceData.selectedSessionId = "";
      this.makeAllStatus = null;
      this.classSessionArr = [];
      this.getClassSession(this.attendanceData.selectedClassId);
    },

    onSessionChange() {
      if (!this.attendanceData.selectedSessionId) return;
      this.makeAllStatus = null;
      this.getClassStudents(this.attendanceData.selectedClassId, this.attendanceData.selectedSessionId);
    },

    logout(error) {
      if (error.response && error.response.status == 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      }
    },

    getClassSession(id) {
      axios.get('my/attendance/class-session/' + id)
        .then((res) => {
          this.classSessionArr = res.data;
        })
        .catch((err) => {
          this.logout(err)
        })
    },

    getClassStudentsPage(page) {
      const classId = this.attendanceData.selectedClassId;
      const sessionId = this.attendanceData.selectedSessionId;

      if (!classId || !sessionId) {
        console.warn("Cannot paginate: classId or sessionId missing");
        return;
      }

      this.getClassStudents(classId, sessionId, page);
    },

    getClassStudents(classId, sessionId) {
      axios.get(`my/attendance/students/${classId}/${sessionId}`)
        .then((res) => {
          this.pg_status = true
          this.classStudents = res.data
        })
        .catch((err) => {
          this.logout(err)
        })
    },

    getClassStatus(statusId) {
      switch (statusId) {
        case 1:
          return "status-present";
        case 2:
          return "status-absent";
        case 3:
          return "status-late";
        case 4:
          return "status-excused";
        default:
          return "";
      }
    },

    submit() {
      this.submitted = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.register()
    },

    register() {
      this.submitted = false
      const request = this.classStudents.filter(s => s.status !== null && s.status !== "").map(s => ({
        class_session_id: this.attendanceData.selectedSessionId,
        student_id: s.student_id,
        status: s.status,
        remark: s.remark
      }))
      if (request.length === 0) {
        this.$notification.error("ရွေးချယ်ထားသော ကျောင်းသားမရှိပါ။", {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }
      axios.post('my/attendance', JSON.stringify(request), {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (!res.data.success) {
            this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                  timer: 3,
                  position: "bottomCenter"
            });
            return
          }
          if (this.$route.name !== "attendanceCreate") {
            this.$router.push({ name: "attendanceCreate" });
          }
          this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
            timer: 3, position: "bottomCenter"
          });
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 422) {
              console.log("Validation failed:", err.response.data.errors);
              this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                  timer: 3,
                  position: "bottomCenter"
              });
            }
          }
          this.logout(err);
        })
    },
  },

  mounted() {
    this.getAllClassForAttendance();
    fetchNotificationCount();
  }
};
